import * as React from "react";
import { Box, Button, Typography, Grid2 } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import { useDispatch } from 'react-redux';
import { SeflieandSignatureStatus, setDummyUser, Signature, } from "../../../Redux/usersSlice";
import SignatureStyles from "./Signature.module.css"
import SignatureCanvas from "react-signature-canvas";
import CryptoJS from "crypto-js";


export default function SignatureMobile() {

    const signCanvasRef = React.useRef(null);
    const dispatch = useDispatch();

    dispatch(setDummyUser())

    const [errMessage, setErrMessage] = React.useState("")
    const [user, setUser] = React.useState({
        mobile: "",
        email: "",
        user_id: ""
    })
    const [isCompleted, setIsCompleted] = React.useState("")
    const [onBegin ,setOnBegin] = React.useState(false)


    const params = new URLSearchParams(window.location.search);

    React.useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "signature_qrpage_viewed",
            page_path: window.location.pathname
        });
        if (params.get("data")) {
            const bytes = CryptoJS.AES.decrypt(params.get("data")?.split(" ")?.join("+"), "96358214256984120");
            const decryptedText = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            console.log(decryptedText, "decoded data");
            setUser({ ...decryptedText })
        }

    }, [])

    React.useEffect(() => {

        if(user.user_id){
            (async ()=>{
                try{
                    const signatureStatus = await dispatch(SeflieandSignatureStatus({mobile : user.mobile ,email : user.email,type : "signature"})).unwrap();
                    if(signatureStatus?.data?.data?.status){
                      setIsCompleted(true)
                    }
                    // AVchanges
                }catch(e){
                    console.log(e)
                }
        
            })()
        }
    }, [user])


    const handleSubmit = async () => {
        setErrMessage("")
        const signData = signCanvasRef.current?.toDataURL("image/jpeg", 100);
        const { mobile, email, user_id } = user
        if (signData.toString().length < 20000) {
            setErrMessage("Signature is too Short")
            return
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "signature_qr_captured",
            page_path: window.location.pathname
        });

        if(onBegin){
            try {
    
                const response = await dispatch(Signature({ mobile, email, user_id, sign_data: signData })).unwrap();
                if (response.data.data.success) {
                    setIsCompleted(true)
                }
    
            } catch (error) {
                setErrMessage("Something went wrong")
                console.error('Error while submitting signature:', error);
            }
        }
    };

    return (
        <main>
        <Box sx={{
            display: "flex",
            minHeight: "100vh !important",
            backgroundImage: `url(${SignUpBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}>

            {/* Your content area */}
            {<Box className={SignatureStyles.content_wrapper}>

                {isCompleted && <Grid2 flexDirection="column" display="flex" justifyContent="center" alignItems="center" height="600px">
                    <Typography className={SignatureStyles.title} sx={{ paddingX: "50px" }}>Your Signature has been completed</Typography>
                    <Button sx={{ marginTop: "30px" }} onClick={() => {
                        setIsCompleted(false)
                    }} className={SignatureStyles.skip_button}>
                        Edit
                    </Button>
                </Grid2>}

                {!isCompleted && <>
                    <Typography className={SignatureStyles.title} sx={{ mt: "50px" }}>
                        Capture Signature
                    </Typography>
                    <Typography className={SignatureStyles.sub_title} sx={{ paddingX: "15px" }}>
                        Draw Signature on screen exactly as per your PAN card
                    </Typography>
                    <div className={SignatureStyles.canva_outer}>
                        <Grid2 className={SignatureStyles.canva_inner} style={{ padding: "0px 20px", width: "100%" }}>
                            <SignatureCanvas
                                ref={(ref) => {
                                    signCanvasRef.current = ref
                                }}
                                onBegin={()=>setOnBegin(true)}
                                penColor="black"
                                canvasProps={{
                                    className: SignatureStyles.sig_canvas
                                }}
                                velocityFilterWeight='0.1'
                                imageType="image/jpeg"
                                backgroundColor='white'
                            />
                            <span
                                onClick={() => signCanvasRef.current.clear()}
                                // Event to clear the canvas
                                className={SignatureStyles.retake1}
                            >
                                Retake
                            </span>
                        </Grid2>
                    </div>
                    {errMessage && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "16px", color: "red !important", marginTop: "0px" }}>
                        {errMessage}
                    </Typography>}
                    <Grid2 className={SignatureStyles.but_card}>
                        <Grid2>
                            <Button onClick={handleSubmit} className={SignatureStyles.con_button}>Submit</Button>
                        </Grid2>
                    </Grid2>
                </>}
            </Box>}

        </Box>
        </main>
    );
}
